import AutomationIcon from "@atlaskit/icon/core/automation";
import ClockIcon from "@atlaskit/icon/core/clock";
import AiSparkleIcon from "@atlaskit/icon/core/ai-sparkle";
import DataFlowIcon from "@atlaskit/icon/core/data-flow";
export const getTriggerName = (triggerType) => {
  if (!triggerType) {
    return (
      <>
        <AiSparkleIcon size="small" />
        Webhook
      </>
    );
  }
  if (triggerType.includes("ATLASSIAN")) {
    return (
      <>
        <AutomationIcon size="small" />
        Issue Event
      </>
    );
  }
  if (triggerType.includes("SCHEDULE")) {
    return (
      <>
        <ClockIcon size="small" />
        Scheduled
      </>
    );
  }
  if (triggerType.includes("LOG")) {
    return (
      <>
        <DataFlowIcon size="small" />
        Scheduled
      </>
    );
  }
  return (
    <>
      <AiSparkleIcon size="small" />
      Webhook
    </>
  );
};
